<template>
	<div id="scheduling">
		<div class="container-fluid">
			<div class="row">
				<div class="content">
					<div class="header">
						<div class="filters-wrapper">
							<div class="filters">
								<i class="fas fa-sliders-h" style="transform: rotate(90deg)"></i>
								<span @click="isFilterListActive = !isFilterListActive">JOBS & FILTERS</span>
								<transition name="fade" appear mode="out-in">
									<settings v-show="isFilterListActive" @shiftColorsChange="handleColorsChange" />
								</transition>
							</div>

							<div class="filter-dropdown">
								<span>Select Store</span>
								<b-form-select
									style="width: 200px;  height: 34px; padding: 5px;"
									v-model="selectedStore"
									:options="storeOptions"
								></b-form-select>
							</div>
						</div>
						<div class="middle-wrapper">
							<div class="dates">
								<span> {{ currentWeek.weekTitle }} </span>
								<div
									class="button-info"
									@mouseover="isWeekInfoVisible = true"
									@mouseleave="isWeekInfoVisible = false"
								>
									i
								</div>
								<transition name="fade" appear mode="out-in">
									<weekInfo v-show="isWeekInfoVisible" />
								</transition>
							</div>
							<div class="progress-wrapper">
								<span class="comletion">Draft Schedule {{ completion }}% completed</span>
								<b-progress height="8px" :value="completion" :max="100"></b-progress>
							</div>
							<button class="btn-publish" @click="handlePublishClick">Publish</button>
						</div>
						<div class="weeks-wrapper">
							<div class="button-left" @click="handlePreviousWeekClick">
								<b-icon-chevron-compact-left />
							</div>
							<div class="indicator">Current Week ({{ currentWeek.weekNumber }})</div>
							<div class="button-right" @click="handleNextWeekClick">
								<b-icon-chevron-compact-right />
							</div>
						</div>
					</div>
					<div class="calendar-days">
						<div>
							<!-- Dont delete me -->
						</div>
						<day
							v-for="(day, index) in currentWeek.days"
							:key="index"
							:title="day.title"
							:revenueFrom="day.revenueFrom"
							:revenueTo="day.revenueTo"
							:index="index"
							:dayInfo="day.dayInfo"
							:isDayInfoButtonVisible="isDayInfoVisible"
						>
						</day>
					</div>
					<div class="calendar-content">
						<div class="job-position">
							<p class="title">Job Position</p>
						</div>
						<template v-for="(jobPosition, index) in jobPositions">
							<div class="shift-row" :key="index" v-if="jobPosition.shiftList.length">
								<div class="position">
									<p class="title">{{ jobPosition.title }}</p>
									<button>+ Shift</button>
								</div>
								<div class="shift-grid">
									<div
										class="shift-day-group"
										v-for="(dayShiftList, index) in jobPosition.shiftList"
										:key="index"
									>
										<shift
											v-for="(shift, index) in dayShiftList.values"
											:key="index"
											:id="shift.id"
											:time="shift.shiftTimeString"
											:employeeFullName="shift.employeeFullName"
											:weather="shift.weather"
											:dateMoment="currentDateTime"
											:position="jobPosition.title"
											:statusColors="convertedShiftColors"
											:status="shift.status"
											:isShiftSelected="selectedShiftId === shift.id"
											@shiftClick="handleShiftClick"
										>
											<!-- <template v-slot:image>
												<img class="employee-img" src="https://via.placeholder.com/150" />
											</template> -->
										</shift>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<!-- <colorPicker defaultColor="#3e3e3e3" /> -->
				<sidebar
					:shiftId="shiftTile.id"
					:isShiftAssigned="shiftTile.isShiftAssigned"
					:date="shiftTile.date"
					:shiftTimeString="shiftTile.shiftTimeString"
					:position="shiftTile.position"
					:event="shiftTile.event"
					:weather="shiftTile.weather"
					:employeeFullName="shiftTile.employeeFullName"
				></sidebar>
			</div>
		</div>
	</div>
</template>

<script>
import day from '@/components/day';
import sidebar from '@/components/sidebar';
import shift from '@/components/shift';
import settings from '@/components/settings';
import weekInfo from '@/components/weekInfo';

// import colorPicker from '@/components/colorPicker';

import {
	dayList,
	getDaysArray,
	getWeekDays,
	shiftList,
	getJobPositionShiftList,
	jobPositions,
	groupByArray,
	isJson,
	storeList,
	jobPositionList,
} from '../api';
import { getForecast } from '../weatherLayer';
import { statusInitialColors } from '../config';

export default {
	name: 'Schedule',
	metaInfo: {
		title: 'Schedule',
	},
	// colorPicker
	components: { day, shift, settings, sidebar, weekInfo },

	data() {
		return {
			completion: 72,
			isFilterListActive: false,
			isWeekInfoVisible: false,
			isDayInfoVisible: false,
			foreCast: [],

			shiftColors: { ...statusInitialColors },
			jobPositions: [...jobPositions],
			shiftTile: {},
			selectedShiftId: 0,
			shiftList: [...shiftList],

			currentWeek: {
				weekNumber: 0,
				weekTitle: '',
				days: [],
			},

			modals: [
				{
					name: '',
					component: '',
				},
			],
			currentModal: '',

			selectedJobPosition: '1',
			selectedStore: '1',
			storeOptions: [...storeList],
			jobPositionOptions: [...jobPositionList],
		};
	},
	created() {
		if (this.localStorageLoad()) {
			this.shiftColors = JSON.parse(this.localStorageLoad());
		} else {
			this.localStorageUpdate(this.shiftColors);
		}
	},
	async mounted() {
		this.foreCast = await getForecast(this.$http, this.$moment, {
			lat: 37.9568,
			lng: 23.742457,
			units: 'metric',
		});

		console.log('getDaysArray', getDaysArray('2020', '3'));
		// get current week number
		this.currentWeek.weekNumber = parseInt(this.$moment().format('W'));

		// get week days from current week
		const weekDayObject = getWeekDays(this.$moment, { current: true });
		this.currentWeek.weekTitle = `${weekDayObject.weekStartDate.date()} - ${weekDayObject.weekEndDate.date()} ${
			weekDayObject.monthString
		} ${weekDayObject.yearString}`;

		// TODO: refactor when data comes
		this.currentWeek.days = dayList.map((day, index) => {
			day.title = weekDayObject.days[index];
			return day;
		});

		this.jobPositions = getJobPositionShiftList(this.$moment).map(jobPosition => {
			const test = jobPosition.shiftList.filter(shift =>
				this.$moment(shift.key).isBetween(weekDayObject.weekStartDate, weekDayObject.weekEndDate, null, '[]'),
			);
			return {
				...jobPosition,
				shiftList: test,
			};
		});
		// TODO remove when day has slot with the info
		this.isDayInfoVisible = !!this.jobPositions[0].shiftList.length;
	},
	computed: {
		canAssignEmployees() {
			return this.shiftTile.shiftStatus === 'unassigned';
		},
		currentDateTime() {
			return this.$moment();
		},
		convertedShiftColors() {
			return isJson(this.shiftColors) ? JSON.parse(this.shiftColors) : this.shiftColors;
		},
	},
	methods: {
		localStorageLoad() {
			return localStorage.getItem('scheduling');
		},
		localStorageUpdate(itemsObject) {
			localStorage.setItem('scheduling', JSON.stringify(itemsObject));
		},
		handleColorsChange(colorsObject) {
			this.shiftColors = colorsObject;
		},
		handleFocus() {
			this.isFilterListActive = true;
		},
		handleFocusOut() {
			this.isFilterListActive = false;
		},
		handleNextWeekClick() {
			this.resolveDates('increase');
		},
		handlePreviousWeekClick() {
			this.resolveDates('decrease');
		},
		handlePublishClick() {
			this.$router.push('overview');
		},
		resolveDates(method) {
			this.currentWeek.weekNumber =
				method === 'increase' ? this.currentWeek.weekNumber + 1 : this.currentWeek.weekNumber - 1;
			const weekDayObject = getWeekDays(this.$moment, { weekNumber: this.currentWeek.weekNumber });

			// TODO: refactor when data comes
			this.currentWeek.weekTitle = `${weekDayObject.weekStartDate.date()} - ${weekDayObject.weekEndDate.date()}
										  ${weekDayObject.monthString} ${weekDayObject.yearString}`;
			this.currentWeek.days = dayList.map((day, index) => {
				day.title = weekDayObject.days[index];
				return day;
			});
			this.jobPositions = getJobPositionShiftList(this.$moment).map(jobPosition => {
				const test = jobPosition.shiftList.filter(shift =>
					this.$moment(shift.key).isBetween(
						weekDayObject.weekStartDate,
						weekDayObject.weekEndDate,
						null,
						'[]',
					),
				);
				return {
					...jobPosition,
					shiftList: test,
				};
			});
			// TODO remove when day has slot with the info
			this.isDayInfoVisible = !!this.jobPositions[0].shiftList.length;
		},
		handleShiftClick(shiftId, position) {
			const currentShift = this.shiftList.find(x => x.id === shiftId);
			this.selectedShiftId = shiftId;
			this.shiftTile = {
				id: currentShift.id,
				shiftStatus: currentShift.status,
				date: currentShift.date,
				shiftTimeString: currentShift.shiftTimeString,
				position: position,
				event: currentShift.event,
				weather: currentShift.weather,
				employeeFullName: currentShift.employeeFullName,
				isShiftAssigned: currentShift.status !== 'unassigned',
			};
		},
	},
};
</script>
<style lang="scss">
#scheduling {
	font-family: 'Open Sans', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #616e84;

	.button-info {
		width: 16px;
		height: 16px;
		font-size: 11px;
		border-radius: 50%;
		color: #fff;
		background-color: #616e84;
		cursor: pointer;
	}

	.content {
		position: relative;
		-webkit-box-flex: 0;
		flex: 0 0 80%;
		max-width: 80%;
		width: 100%;
		padding-right: 0;
		padding-left: 15px;
		border-right: solid 1px #e6e6e6;

		.header {
			position: relative;
			width: 100%;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			padding: 20px 0;
			border-bottom: solid 1px #e6e6e6;

			.filters-wrapper {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;

				.filter-dropdown {
					display: flex;
					flex-direction: row;
					width: 100%;
					align-items: center;
					span {
						font-size: 15px;
						font-weight: 300;
						width: 100px;
						margin-right: 5px;
					}
				}

				.filters {
					position: relative;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					z-index: 2;
					width: 135px;
					// height: 40px;
					padding: 7px 12px;
					margin-right: 25px;
					border-radius: 3.2px;
					box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.21);
					background-color: #ffffff;

					& > span {
						font-size: 11.2px;
						font-weight: bold;
						cursor: pointer;
						color: #76839a;
					}

					.filter-box {
						position: absolute;
						top: 0;
						left: 0;
						width: 302px;
						height: 307px;

						z-index: -1;
						background-color: #fff;
						box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.21);
						outline: none;
					}
					.filter-box:focus {
						outline: none;
					}
				}
			}
			.middle-wrapper {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;

				.dates {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					span {
						font-size: 22px;
						color: #616e84;
						margin-right: 20px;
					}
				}
				.progress-wrapper {
					width: 170px;
					margin-left: 20px;
					.comletion {
						font-size: 11px;
					}
				}
				.btn-publish {
					margin-left: 20px;
					padding: 4px 10px;
					font-size: 14px;
					border-radius: 3px;
					border-color: transparent;
					background-color: #616e84;
					color: #fff;
				}
			}
			.weeks-wrapper {
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;

				.button-left,
				.button-right,
				.indicator {
					margin-right: 10px;
				}

				.indicator {
					border-radius: 3px;
					font-size: 14px;
					border: solid 1px #eceded;
					background-color: #ffffff;
					color: #616e84;
					padding: 5px;
				}

				.button-right,
				.button-left {
					width: 32.5px;
					height: 32.5px;
					// padding: 5px;
					font-size: 23px;

					border-radius: 3px;
					border: solid 1px #eceded;
					background-color: #ffffff;
					cursor: pointer;
				}
			}
		}
		.calendar-days {
			display: grid;
			grid-template-columns: repeat(8, auto);
			align-items: center;
			padding: 20px 20px 0;
			border-bottom: solid 1px #e6e6e6;
		}
		.calendar-content {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			margin-top: 10px;

			.job-position {
				width: 100%;
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				align-items: center;
				border-bottom: solid 1px #ffb03f;

				.title {
					font-size: 12px;
					font-weight: bold;
					margin-bottom: 6px;
				}
			}

			.shift-row {
				display: flex;
				width: 100%;
				margin-top: 15px;
				border-bottom: solid 1px #ffb03f;

				.position {
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					justify-content: flex-start;
					width: 130px;

					.title {
						font-size: 12px;
						color: #616e84;
					}
					button {
						width: 54.5px;
						height: 21px;
						border-radius: 3px;
						border: solid 1px #e0e0e0;
						background-color: #e7e8e9;
						font-size: 9px;
					}
				}
				.shift-grid {
					// display: grid;
					// grid-template-columns: repeat(7, auto);
					display: flex;
					width: 100%;

					.shift-day-group {
						display: grid;
						grid-template-columns: repeat(1, auto);
						align-items: self-start;
						width: 100%;
						margin-bottom: 30px;
						height: min-content;
						.shifts {
						}
					}
				}
			}
		}
	}
}
</style>
